import { DocFlowStatus } from '../../constants/docFlow'
import {
  REQUEST_IN_PROGRESS_STATUS,
  REQUEST_PENDING_STATUS,
} from '../../constants/request'
import { getDescSortParam } from '../../utils/sort'

export const BIRDVIEW_SECTION_ITEMS_LIMIT = 5

export const BIRDVIEW_UNREAD_EMAILS_FIRST_PAGE = 1

export const BIRDVIEW_OPEN_REQUEST_STATUSES = [
  REQUEST_PENDING_STATUS,
  REQUEST_IN_PROGRESS_STATUS,
]

// Ascending date ordering puts nulls first on the backend, so the lists follow
// recency until the ranking of BR-DASH-05 lands server-side.
export const BIRDVIEW_REQUESTS_ORDERING = [getDescSortParam('private_updated')]

export const BIRDVIEW_ACTIVITIES_ORDERING = [getDescSortParam('updated')]

export const BIRDVIEW_BUILDINGS_ORDERING = ['title']

export const BIRDVIEW_DOC_FLOWS_ORDERING = [getDescSortParam('updated')]

export const BIRDVIEW_POSTS_ORDERING = [getDescSortParam('created')]

export const BIRDVIEW_CHATS_ORDERING = [getDescSortParam('last_message_date')]

export const BIRDVIEW_FLATS_ORDERING = ['number']

export const BIRDVIEW_POSTS_SUB_MENU = 'newsboard'

export const BIRDVIEW_DOC_FLOW_OPEN_STATUSES = [
  DocFlowStatus.Pending,
  DocFlowStatus.InProgress,
]
